import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { WindowRef } from '../../../../../../shared/_services/windowRef';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-hca-loyalty-website-font-color',
  templateUrl: './hca-loyalty-website-font-color.component.html',
  styleUrls: ['./hca-loyalty-website-font-color.component.scss']
})
export class HcaLoyaltyWebsiteFontColorComponent implements OnInit {
  loyaltyFormEn: FormGroup;
  brand: any;
  hotelBrands: any;
  nativeWindow: any;
  errorDetails: any;
  successMsg: string;
  private subscription: Subscription;
  cssTextStyle ="/* ------Template ---- */\n\nbutton {\n    font: 10px;\n    color: #f37b20;\n  }\n\ntext {\n    font: 20px;\n    color: #0078c5;\n  }\n\ncontent {\n    font: 10px;\n    color: #0078c5;\n  }  \n/* ------Template ---- */";
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(
    public modalService: BsModalService,
    private hcaUserManagementService: HcaUserManagementService,
    private hotelManagementService: HotelManagementService,
    public translate: TranslateService,
    // private winRef: WindowRef,
    private loyaltyService: LoyaltyService,
    private fb: FormBuilder
  ){
    // this.nativeWindow = winRef.nativeWindow;
    let user = JSON.parse(localStorage.getItem('loggedInUser'));
    translate.setDefaultLang('en');
    translate.use('en');
    this.modalService.onHide
    .takeUntil(this.unsubscribe).subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.type == "hca-wizard") {
          if (this.statusModal.content.srcObject.action == "action1") {
            this.loyaltyFormEn.patchValue(this.loyaltyFormEn.get('resetData').value, { emitEvent: false });
          }
        }
        
      }
    })
  }
        

  getWebsiteCss(brandId) {
    this.loyaltyService.getWebsiteCss(brandId).subscribe(res => {
      if(res.error == 0) {
        if(res.responseObj) {
          this.initForm(res.responseObj.cssTextStyle);
        } else {
          this.initForm(null);
        }
      }
    }, err => {
      console.error('Error fetching loyalty website header and footer data', err);
    })
  }

  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  resetField(field?, form?) {
    if(field && form) {
      this[form].controls[field].patchValue(this[form].controls['resetData'].value, {emitEvent: false});
    }
  }

  openPreview() {
    var previewWindow = this.nativeWindow.open('/hca-loyalty-website-preview');
    // previewWindow.brandId = this.hotelManagementService.getSelectedBrand().brandId;
    // previewWindow.langType = this.translate.currentLang == 'en' ?  {languageId: 1 , language: 'English'} : {languageId: 2 , language: 'Spanish'};
    // previewWindow.headerAndFooter = null;
    // previewWindow.fontData = JSON.stringify(this.loyaltyFormEn.value); 

  }

  saveForm() {
    this.hotelManagementService.getSelectedBrand()
    let formData = {
      brandId: this.hotelManagementService.getSelectedBrand().brandId,
      colorSchemeTo: this.loyaltyFormEn.value
    }
    this.loyaltyService.saveLoyaltyWebsite(formData).subscribe(res => {
      this.successMsg = 'Saved successfully';
      setTimeout(() => {
        this.successMsg = '';
      }, 1000);
    }, err => {
      this.errorDetails = err.message ? err.message : 'Error while saving';
      setTimeout(() => {
        this.errorDetails = '';
      }, 1000);
      console.error('Error saving', err.message);
    })
  }

  initForm(data?: any) {
    let defaultData = this.cssTextStyle;
    this.loyaltyFormEn = this.fb.group({
      languageId: [1],
      cssTextStyle: [data ? data : this.cssTextStyle],
      resetData: [data ? data : defaultData]
    })
    
  }

  cancel() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-wizard',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to cancel out of configuring the Website CSS?',
      action1: 'Yes',
      action2: 'No',
      action: '',
      style: 'active'
    }
  }

  ngOnInit() {
    this.getHotelBrandsByHotelChain();
    this.subscription = this.loyaltyService.brandState
    .subscribe((state: any) => {
      this.brand = state.brand;
      this.getWebsiteCss(this.brand.brandId);
    });
    this.initForm(null);
  }

  ngAfterViewInit(){
    this.brand = this.hotelManagementService.getSelectedBrand(); 
    this.getWebsiteCss(this.brand ? this.brand.brandId : null);
  
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/hca-loyalty-website-font-color/hca-loyalty-website-font-color.component.ts